import { Box } from '@mui/system';
import React, { FC } from 'react';

type Props = {
    children: React.ReactNode;
};

export const MainContainer: FC<Props> = (props) => {
    return (
        <Box component='section' sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 44px)', paddingX: 7, paddingTop: 3, paddingBottom: 1, overflowY: 'scroll' }}>
            {props.children}
        </Box>
    );
};
